// 给热点标签添加 active 切换
document.addEventListener('DOMContentLoaded', function() {
  const items = document.querySelectorAll('.shopable-image-item');
  
  items.forEach(function(item) {
    item.addEventListener('click', function(e) {
      // 关闭其他已打开的
      items.forEach(function(other) {
        if (other !== item) other.classList.remove('active');
      });
      // 切换当前
      item.classList.toggle('active');
      e.stopPropagation();
    });
  });

  // 点击空白处关闭
  document.addEventListener('click', function() {
    items.forEach(function(item) {
      item.classList.remove('active');
    });
  });
});

// button-quickview 空定义，防止报错
class ButtonQuickview extends HTMLElement {}
customElements.define('button-quickview', ButtonQuickview);

